(function () {
  window.addEventListener('DOMContentLoaded', () => {
    let drawer = document.querySelector('.js-filter-drawer');

    if (!drawer) return;

    drawer.style.transition = 'transform 200ms ease-out';

    let filterList = document.querySelector('.js-filter-list');
    let view = document.querySelector(
      '#collection-products-' + drawer.dataset.id
    );
    let grid = view.querySelector('.js-collection-products-grid');
    let viewAll =
      view.querySelector('.js-collection-products__view-all') &&
      view
        .querySelector('.js-collection-products__view-all')
        .closest('.collection-products__view-all-wrapper');

    let filters = [];

    function saveFilters() {
      filters.forEach((filter) => {
        filter.items.forEach((item) => {
          if (
            filter.key === 'filter.v.price.gte' ||
            filter.key === 'filter.v.price.lte'
          ) {
            item.element.dataset.oldValue = item.value;
          } else {
            item.element.dataset.oldValue = item.selected || '';
          }
        });
      });
    }

    function restoreSavedFilters() {
      filters.forEach((filter) => {
        filter.items.forEach((item) => {
          if (
            filter.key === 'filter.v.price.gte' ||
            filter.key === 'filter.v.price.lte'
          ) {
            item.value = item.element.dataset.oldValue;
          } else {
            item.selected = item.element.dataset.oldValue;
          }
        });
      });
    }

    // get filters from html
    function getFilters() {
      let filterLists = drawer.querySelectorAll('[data-filter]');

      filters = Array.prototype.map.call(filterLists, function (list) {
        let filterItems = list.querySelectorAll('[data-filter-value]');

        let items = Array.prototype.map.call(filterItems, function (item) {
          return {
            value: item.dataset.filterValue,
            label: item.textContent.trim(),
            element: item,
            selected: false,
          };
        });

        return {
          key: list.dataset.filter,
          multiple: list.hasAttribute('data-checkbox'),
          items: items,
        };
      });

      saveFilters();
    }

    // render selected filters using filters object
    function renderFilters() {
      filters.forEach(function (filter) {
        filter.items.forEach(function (item) {
          if (item.selected) {
            item.element.classList.add('filter-drawer__list-item--selected');
          } else {
            item.element.classList.remove('filter-drawer__list-item--selected');
          }
        });

        if (filter.key === 'filter.v.price.gte') {
          setRangeValue((+filter.items[0].value / maxPrice) * 100, 'min');
        }

        if (filter.key === 'filter.v.price.lte') {
          setRangeValue((+filter.items[0].value / maxPrice) * 100, 'max');
        }
      });
    }

    // add handlers to filter items
    function setFilterHandlers() {
      filters.forEach(function (filter) {
        filter.items.forEach(function (item) {
          item.element.addEventListener('click', function () {
            if (filter.multiple) {
              item.selected = !item.selected;
            } else {
              if (!item.selected) {
                filter.items.forEach(function (i) {
                  i.selected = false;
                });

                item.selected = true;
              }
            }

            renderFilters();
          });
        });
      });
    }

    // apply filter to product grid
    function applyFilters() {
      let urls = buildUrls();

      fetchProducts(urls).then(function () {
        renderFilterTags();
      });

      saveFilters();
    }

    // build urls for fetching product
    function buildUrls() {
      let qs = [];
      let collections = [];

      filters.forEach(function (filter) {
        filter.items.forEach(function (item) {
          if (item.selected) {
            if (filter.key === 'collection') {
              collections.push(item.value);
            } else {
              qs.push(`${filter.key}=${item.value}`);
            }
          }
        });
      });

      if (!collections.length) {
        collections.push('all');
      }

      return collections.map(function (collection) {
        return `/collections/${collection}/?sections=collection-products-ajax&${qs.join('&')}`;
      });
    }

    // fetch products
    function fetchProducts(urls) {
      let promises = urls.map(function (url) {
        return fetch(url).then((res) => res.json());
      });

      return Promise.all(promises).then(function (res) {
        let products = '';

        res.forEach(function (r) {
          let tmp = document.createElement('div');
          tmp.innerHTML = r['collection-products-ajax'];
          products += tmp.firstChild.innerHTML.replace(
            /{id}/g,
            drawer.dataset.id
          );
        });

        grid.innerHTML = products;

        let productEl = grid.querySelectorAll('.js-collection-products-tile');

        Array.prototype.forEach.call(productEl, function (el, i) {
          //if (i >= 8) {
          //el.classList.add('collection-products-tile--hidden');
          //}
        });

        //if (productEl.length > 8) {
        //viewAll.style.display = 'flex';
        //} else {
        if (viewAll) {
          viewAll.style.display = 'none';
        }
        //}
      });
    }

    // render filter tags
    function renderFilterTags() {
      let filterCount = 0;
      let filterHTML = '';

      filters.forEach(function (filter) {
        filter.items.forEach(function (item) {
          if (item.selected) {
            let label = item.label;
            if (filter.key === 'filter.v.price.gte') {
              label = `>= ${item.value}`;
            }

            if (filter.key === 'filter.v.price.lte') {
              label = `<= ${item.value}`;
            }

            filterCount++;
            filterHTML += `<button class="collection-products-filter__item js-collection-product-filter__item" data-filter-value="${item.value}"><div class="close-circle-icon"><svg><use href="#close-circle"></use></svg></div><span>${label}</span></button>`;
          }
        });
      });

      filterList.innerHTML = filterHTML;
      Array.prototype.forEach.call(filterToggleButtons, function (button) {
        if (filterCount) {
          button.querySelector('span').innerHTML =
            'FILTER & SORT <sup>+</sup>' + filterCount;
        } else {
          button.querySelector('span').innerHTML = 'FILTER & SORT';
        }
      });
    }

    getFilters();
    setFilterHandlers();

    function openDrawer() {
      restoreSavedFilters();
      renderFilters();
      drawer.classList.add('filter-drawer--active');
      document.body.style.top = '-' + window.scrollY + 'px';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
    }

    function closeDrawer() {
      drawer.classList.remove('filter-drawer--active');
      document.body.style.overflow = '';
      document.body.style.position = '';
      window.scrollTo(0, +document.body.style.top.replace('px', '') * -1);
      document.body.style.top = '';
    }

    let filterToggleButtons = document.querySelectorAll('.js-filter-toggle');
    Array.prototype.forEach.call(filterToggleButtons, function (btn) {
      btn.addEventListener('click', openDrawer);
    });

    // close button
    let close = drawer.querySelector('.js-filter-drawer__close');
    close.addEventListener('click', closeDrawer);

    // close when clicking outside the drawer
    document.addEventListener('click', function (e) {
      if (
        !e.target.matches('.js-filter-drawer') &&
        !e.target.closest('.js-filter-drawer') &&
        !e.target.matches('.js-filter-toggle') &&
        !e.target.closest('.js-filter-toggle') &&
        drawer.classList.contains('filter-drawer--active')
      ) {
        closeDrawer();
      }
    });

    // apply filter button
    let applyFilter = drawer.querySelector('.js-filter-apply');
    let filterToggleBtn = document.querySelectorAll('.js-filter-toggle')[0];

    filterToggleBtn.addEventListener('click', function () {
      dataLayer.push({ event: 'filter_and_sort' });

    });
    applyFilter.addEventListener('click', function () {
      var rangeValues = [];
      var sortValues = []
      var whiskeyTypeValues = [];
      var priceMin = 0;
      var priceMax = 400;
      filters.forEach(function (filter) {
        
        filter.items.forEach(function (item) {
          if (item.selected) {
           
            if(item.element.parentNode.parentNode.className == "filter-drawer__range-value"){
              var pp = item.element.parentNode.parentNode;
              priceMin = pp.querySelectorAll('.js-range-min')[0].innerText;
              priceMax = pp.querySelectorAll('.js-range-max')[0].innerText;
            }
            else if(item.element.parentNode.parentNode.querySelectorAll('.filter-drawer__header')[0].innerText == "SORTING"){
              sortValues.push(item.label);
            }
            else if(item.element.parentNode.parentNode.querySelectorAll('.filter-drawer__header')[0].innerText == "RANGE"){
              rangeValues.push(item.label);
            }
            else if(item.element.parentNode.parentNode.querySelectorAll('.filter-drawer__header')[0].innerText == "WHISKEY TYPE"){
              whiskeyTypeValues.push(item.label);
            }
           
            
          } 
        });

      });

      dataLayer.push({
        'event': 'Filter',
        'range': {
        'value': rangeValues.toString()
        },
        'sorting': {
        'value': sortValues.toString()
        },
        'whiskeyType': {
        'value': whiskeyTypeValues.toString()
        },
        'priceRange': {
        'valuemin': priceMin,
        'valuemax': priceMax
        }
        });
        
      applyFilters();
      closeDrawer();
    });

    // price range
    let range = document.querySelector('.js-range');
    let rangeSelectors = range.querySelectorAll('.js-range-selector');
    let minRange = document.querySelector('.js-range-selector--min');
    let maxRange = document.querySelector('.js-range-selector--max');
    let rangeValueMin = document.querySelector('.js-range-min');
    let rangeValueMax = document.querySelector('.js-range-max');
    let maxPrice = 400;
    let min = 0,
      max = 100;

    range.addEventListener('pointerdown', (e) => {
      range.setPointerCapture(e.pointerId);

      moveSlider(e);
      range.addEventListener('pointermove', moveSlider);

      range.addEventListener(
        'pointerup',
        () => {
          range.removeEventListener('pointermove', moveSlider);
        },
        { once: true }
      );
    });

    function moveSlider(e) {
      const rect = e.target.getBoundingClientRect();
      let value = ((e.clientX - rect.left) / rect.width) * 100;

      if (value < 0) value = 0;
      if (value > 100) value = 100;

      if (Math.abs(value - min) < Math.abs(value - max)) {
        min = value;
        setRangeValue(value, 'min');
      } else {
        max = value;
        setRangeValue(value, 'max');
      }
    }

    function valueToPx(value) {
      let px = (value / 100) * range.clientWidth - 14;

      if (px < 0) px = 0;
      if (px > range.clientWidth - 28) px = range.clientWidth - 28;

      return px;
    }

    function setRangeValue(value, type) {
      let priceValue = Math.round((value / 100) * maxPrice);

      if (type === 'min') {
        let filter = filters.find((f) => f.key === 'filter.v.price.gte');
        filter.items[0].selected = value !== 0;
        filter.items[0].value = priceValue;

        rangeValueMin.firstChild.innerHTML = priceValue;
        minRange.style.left = `${valueToPx(value)}px`;
      } else {
        let filter = filters.find((f) => f.key === 'filter.v.price.lte');
        filter.items[0].selected = value !== 100;
        filter.items[0].value = priceValue;

        rangeValueMax.firstChild.innerHTML = priceValue;
        maxRange.style.left = `${valueToPx(value)}px`;
      }
    }

    // header accordion
    let headers = drawer.querySelectorAll('.js-filter-header');
    Array.prototype.forEach.call(headers, function (header) {
      header.addEventListener('click', function () {
        $(header).next().slideToggle();

        header.classList.toggle('filter-drawer__header--hidden');

        if (header.classList.contains('filter-drawer__header--hidden')) {
          header.querySelector('use').setAttribute('href', '#arrow-right');
        } else {
          header.querySelector('use').setAttribute('href', '#minus');
        }
      });
    });

    // clear all button
    let clearAll = drawer.querySelector('.js-filter-clear-all');
    clearAll.addEventListener('click', function () {
      filters.forEach(function (filter) {
        filter.items.forEach(function (item) {
          item.selected = false;

          if (filter.key === 'filter.v.price.gte') {
            item.value = 0;
          }

          if (filter.key === 'filter.v.price.lte') {
            item.value = maxPrice;
          }
        });
      });

      renderFilters();
      applyFilters();
      closeDrawer();
    });

    document.addEventListener('click', function (e) {
      let tag = e.target.classList.contains(
        'js-collection-product-filter__item'
      )
        ? e.target
        : e.target.closest('.js-collection-product-filter__item');

      if (tag) {
        filters.forEach(function (filter) {
          filter.items.forEach(function (item) {
            if (item.value.toString() === tag.dataset.filterValue) {
              item.selected = false;

              if (filter.key === 'filter.v.price.gte') {
                item.value = 0;
              }

              if (filter.key === 'filter.v.price.lte') {
                item.value = maxPrice;
              }
            }
          });
        });

        renderFilters();
        applyFilters();
      }
    });
  });
})();
